import { CellExportFormats } from '../xlsxExport.constants';

const isExportFormatForNumber = exportFormat => {
  switch (exportFormat) {
    case CellExportFormats.NUMBER:
    case CellExportFormats.PERCENT_6:
    case CellExportFormats.PERCENT_4:
      return true;
    default:
      return false;
  }
};

export default isExportFormatForNumber;
